import { render } from "./LayoutDiv.vue?vue&type=template&id=21efbc8e"
import script from "./LayoutDiv.vue?vue&type=script&lang=js"
export * from "./LayoutDiv.vue?vue&type=script&lang=js"

import "./LayoutDiv.vue?vue&type=style&index=0&id=21efbc8e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__